import {observer} from "mobx-react";
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {
    DialogButtonClickHandleResultEnum,
    IModalDialogHandler,
    ISimpleTextModalButtonOptions
} from "../../../../services/dialog/dialog.service.interface";
import {SimpleMessageDialogButtonBox} from "./boxes/simple-message-dialog-button.box";
import React from "react";

interface SimpleMessageButtonComponentProps {
    buttonOptions: ISimpleTextModalButtonOptions;
    numberOfButtons: number;
    dialogHandler: IModalDialogHandler;
}

@observer
export class SimpleMessageButtonComponent extends OrbitComponent<SimpleMessageButtonComponentProps> {
    private _onClickHandler = async () => {
        const button = this.props.buttonOptions;
        const result =  await button.onClick();
        if(result === DialogButtonClickHandleResultEnum.CloseDialogAndContinue) {
            this.props.dialogHandler.close();
        }
    }
    render() {
        const button = this.props.buttonOptions;
        return (
            <SimpleMessageDialogButtonBox key={button.text}
                                          preset={button.buttonPreset}
                                          onClick={this._onClickHandler}
                                          buttonWidthProportionOnPC={Math.max(2, this.props.numberOfButtons)}> {/* On PC in general we don't want a button to have 100% width */}
                {button.text}
            </SimpleMessageDialogButtonBox>
        )
    }
}